import { Table } from 'antd'
import BackButton from 'components/BackButton'
import { addCommasToNumber } from 'helpers'
import moment from 'moment'
import { useDepositTransaction } from 'services/swr/transaction'
import { twMerge } from 'tailwind-merge'
import useTranslation from 'translations/useTranslation'
import { formatUnits, toSentenceCase } from 'utils'

const WalletHistoryPage = () => {
	const { t } = useTranslation()

	const { data } = useDepositTransaction()

	return (
		<div className='flex flex-col items-center gap-5'>
			<BackButton title={t('Transaction History')} />

			<Table
				className='w-full'
				pagination={data?.length < 6 ? false : {
					showSizeChanger: false,
                    pageSize: 6,
				}}
				dataSource={data}
				loading={!data}
				rowKey={(record: any) => record.id}
				// scroll={{ x: 450 }}
				columns={[
					// {
					// 	title: "Token",
					// 	dataIndex: 'token',
					// 	align: "center",
					// 	render: (value) => <span className='text-xs'>{value?.symbol || "--"}</span>,
					// },
					{
						title: t("chain"),
						dataIndex: 'network',
						align: "center",
						render: (value) => <span className='text-[11px] sm:text-xs'>{value || "--"}</span>,
					},
					{
						title: t("Amount"),
						dataIndex: 'amount',
						align: "center",
						render: (value, record) => (
							<span className={twMerge('text-xs font-bold', record.direction === "out" ? 'text-red-500' : 'text-green-500')}>
								{!record ? "" : (record.direction === "out" ? "-" : "+")}
								{!record ? "--" : addCommasToNumber(formatUnits(value, +record.token.decimals), 2)}
								{" "}
								{record.token.symbol}
							</span>
						),
					},
                    {
						title: t("Type"),
						dataIndex: 'type',
						align: "center",
                        render: (value) => <span className='text-[10px] sm:text-xs'>{toSentenceCase(t(value)) || "--"}</span>,
					},
					{
						title: t("Time"),
						dataIndex: 'confirmed_at',
						render: (value) => (
							<div className="flex flex-col items-center">
								<span className='text-[10px] sm:text-xs'>{moment.utc(value).format("YYYY/MM/DD")}</span>
								<span className='text-[10px] sm:text-xs'>{moment.utc(value).format("HH:mm")}</span>
							</div>
						),
						align: "center",
					},
				]}
			/>
		</div>
	)
}

export default WalletHistoryPage